import axios from "axios";
import { API_BASE_URL } from "../../../config";

export const getMarkHomeUserMsg = async (conversationId) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/Chat/MarkHomeUserMessageAsRead`, {
            params: {
                conversationId,
            },
        });
        return response.data;
    } catch (error)
    {
        console.error("Error fetching MarkHomeUserMessageAsRead:", error);
        throw error;
    }
};
